import { render, staticRenderFns } from "./Lantern.vue?vue&type=template&id=c52b7848&scoped=true&"
import script from "./Lantern.vue?vue&type=script&lang=js&"
export * from "./Lantern.vue?vue&type=script&lang=js&"
import style0 from "./Lantern.vue?vue&type=style&index=0&id=c52b7848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52b7848",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
